import React, { useEffect, useRef, useState } from 'react';

import { setLicenseKey, scanDocument } from '@thegrizzlylabs/web-geniusscan-sdk';
import _ from 'lodash';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const LICENSE_KEY_FOR_YOUR_DOMAIN = isLocalhost
	? '533c50075050090202550450395d5a00050f5a0b47426d085502025f030b000254'
	: '533c5007505e0102045701523942450b0111574a4743425c105f5b1443595e5b0e5d0a074b1b5558086d0005565a000453565001';

setLicenseKey(LICENSE_KEY_FOR_YOUR_DOMAIN).catch((e) => {
	console.error(`Error setting Genius Scan SDK license key`, e);
});

const blobToBase64 = (blob) => {
	const reader = new FileReader();
	reader.readAsDataURL(blob);
	return new Promise((resolve) => {
		reader.onloadend = () => {
			resolve(reader.result);
		};
	});
};

export const GeniusScanner = ({ savePhoto, onClose, setSavePhoto, setJpegForUpload }) => {
	/*
	useEffect(() => {
		setLicenseKey(LICENSE_KEY_FOR_YOUR_DOMAIN).catch((e) => {
		  console.error(`Error setting Genius Scan SDK license key`, e);
		});
	  }, []);
	  */

	useEffect(() => {
		setCameraOn(true);
	}, []);

	const containerRef = useRef(null);

	const setCameraOn = async () => {
		try {
			const jpegImages = await scanDocument({
				highlightColor: 'orange',
				multiPage: false,
				defaultFilter: 'none',
			});

			// We only want one jpeg
			const jpegBlob = _.first(jpegImages);
			if (!jpegBlob) {
				onClose();
				return;
			}

			//	console.log('JPEG', jpegImages);
			//jpegImages.forEach((jpeg) => {
			//const jpegUrl = URL.createObjectURL(jpeg);
			//const img = document.createElement('img');
			//img.src = url;
			//img.onload = () => URL.revokeObjectURL(url);
			//containerRef.current.appendChild(img);
			//});

			blobToBase64(jpegBlob).then((base64Jpeg) => {
				// do what you wanna do
				//saveJpeg(jpegUrl);
				setJpegForUpload(base64Jpeg);
				setSavePhoto(false);
				///.console.log(res); // res is base64 now
			});
		} catch (error) {
			console.error('Scan error', error);
			alert(`Error scanning document: ${error.message}`);
		}
	};

	return (
		<div>
			<div
				ref={containerRef}
				style={{ marginTop: '5rem', color: '#666', fontSize: '120%', textAlign: 'center' }}
			>
				No photo yet.
				<br />
				Please click "Open Camera"
			</div>
		</div>
	);
};
